export const CHARGE_POPULATE_FULL = [
    "pm_subscription.strategy",
    "pm_payments",
    "pm_issuerBillingData",
    "pm_recipientBillingData",
    "bot_config.exchange_account",
    "pm_user",
];
export const CHARGE_POPULATE_LIST = [
    "pm_subscription.strategy",
    "bot_config",
    "pm_user",
];
export const CHARGE_POPULATE_MINIMAL = ["bot_config", "pm_user"];
export const CHARGE_POPULATE = {
    FULL: CHARGE_POPULATE_FULL,
    LIST: CHARGE_POPULATE_LIST,
    MINIMAL: CHARGE_POPULATE_MINIMAL,
};
export const REFUND_POPULATE_FULL = [
    "pm_issuerBillingData",
    "pm_recipientBillingData",
    "bot_config.exchange_account",
    "pm_user",
];
export const REFUND_POPULATE_LIST = ["bot_config", "pm_user"];
export const REFUND_POPULATE = {
    FULL: REFUND_POPULATE_FULL,
    LIST: REFUND_POPULATE_LIST,
};
export const PAYOUT_POPULATE_FULL = [
    "pm_issuerBillingData",
    "pm_recipientBillingData",
    "pm_user",
];
export const PAYOUT_POPULATE_LIST = ["pm_user"];
export const PAYOUT_POPULATE = {
    FULL: PAYOUT_POPULATE_FULL,
    LIST: PAYOUT_POPULATE_LIST,
};
